module.exports = __webpack_public_path__ + "static/media/sports_27.c954a378.jpg";